import React from 'react';
import styles from './index.module.less';
import Icon from 'components/Icon';
import classNames from 'classnames';
import scan from '@/public/images/scan.png';
import qr from '@/public/images/qr.png';
import Image from 'next/image';

const Index: React.FC = () => {
  return (
    <div className={styles.mj_social_container}>
      <div className={styles.mj_social_left}>
        <div className={styles.mj_social_left_text}>关注我们获取最新动态</div>
        <div className={styles.mj_social_left_wechat}>
          <div className={styles.mj_social_left_wechat_QR}>
            <Image src={scan} alt="" />
            <Image
              className={styles.mj_social_left_wechat_QR_img}
              src={qr}
              alt=""></Image>
          </div>
          <Icon
            fontClass="ICON-33"
            style={{
              cursor: 'pointer',
              fontSize: 50,
              color: '#4d4d4d',
            }}
          />
        </div>
        <Icon
          onClick={() => {
            window.open('https://weibo.com/6124450240');
          }}
          fontClass="ICON-34"
          style={{
            cursor: 'pointer',
            fontSize: 50,
            color: '#4d4d4d',
          }}
        />
        <Icon
          onClick={() => {
            window.open('https://space.bilibili.com/626332915');
          }}
          fontClass="ICON-35"
          style={{
            cursor: 'pointer',
            fontSize: 50,
            color: '#4d4d4d',
          }}
        />
      </div>
      <div className={styles.mj_social_middle}></div>
      <div className={styles.mj_social_right}>
        <div className={styles.mj_social_right_text}>相关网站</div>
        <div
          onClick={() => {
            window.open('https://www.manjuu.com/zh/');
          }}
          className={classNames([
            styles.aboutUs_link,
            styles.aboutUs_link_btn,
          ])}>
          <div className={styles.aboutUs_link_content}>
            蛮啾游戏官网
            <Icon
              className={styles.aboutUs_link_right_arrow}
              color="#fff"
              fontClass="ICON-28"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
